export enum ErrorType {
    console,alret,dialog,message
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/error/error-type.enum.ts